import { render, staticRenderFns } from "./DeliveryFee.vue?vue&type=template&id=0803ee7d"
import script from "./DeliveryFee.vue?vue&type=script&lang=js"
export * from "./DeliveryFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports